import React from 'react';
import { motion } from 'framer-motion';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/05374aa8-3497-468f-a5da-2243f6f2d173.jpg';
const ease = [0.22, 1, 0.36, 1] as const;
export function Hero() {
  return <section id="top" className="bg-warmwhite pt-24 sm:pt-28" data-id="element-100" data-mp="9lbkfd8rfxje">
      <div className="mx-auto max-w-6xl px-6 sm:px-10" data-id="element-101" data-mp="4mi47d239sfj">
        <motion.p initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.15,
        ease
      }} className="font-sans text-[0.62rem] font-light uppercase tracking-widest text-sage-600" data-id="element-102" data-mp="4jvv38zjv4v7">
          Fresh Guide #1
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 22
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.2,
        delay: 0.28,
        ease
      }} className="mt-6 max-w-3xl font-serif text-[2.4rem] font-light leading-[1.08] tracking-[-0.01em] text-ink-900 sm:text-6xl lg:text-[4.5rem]" data-id="element-103" data-mp="nc876ng09kij">
          Los 7 errores que hacen que una crema no funcione{' '}
          <em className="font-light italic text-sage-600" data-id="element-104" data-mp="3j6oc9l508oqm">(aunque sea cara)</em>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.1,
        delay: 0.42,
        ease
      }} className="mt-8 max-w-xl font-sans text-[1.02rem] font-light leading-[1.85] text-ink-500 sm:text-lg" data-id="element-105" data-mp="3o59bpicfn4e0">
          Antes de invertir en otra crema, entendé por qué muchas rutinas no
          funcionan y qué podés hacer para cambiarlo.
        </motion.p>
      </div>

      <motion.figure initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1.4,
      delay: 0.5,
      ease
    }} className="mt-14 sm:mt-20" data-id="element-106" data-mp="2qkmune40zuq0">
        <div className="mx-auto max-w-6xl px-6 sm:px-10" data-id="element-107" data-mp="2hincujl6smm0">
          <div className="grain relative overflow-hidden rounded-[1.75rem] bg-cream sm:rounded-[2.5rem]" data-id="element-108" data-mp="2hl9puyqujubm">
            <motion.img src={HERO_IMAGE} alt="Mujer de espaldas junto a una ventana con una hoja botánica con gotas de agua sobre lino color crema" className="h-[68vh] w-full object-cover sm:h-[78vh]" initial={{
            scale: 1.08
          }} animate={{
            scale: 1
          }} transition={{
            duration: 2.4,
            delay: 0.4,
            ease
          }} data-id="element-109" data-mp="2lml8ulf7thau" />
          </div>
        </div>
      </motion.figure>

      <div className="mx-auto max-w-6xl px-6 sm:px-10" data-id="element-110" data-mp="1azumrik0svzh">
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1.2,
        delay: 0.9,
        ease
      }} className="mt-8 max-w-md font-sans text-[0.78rem] font-light leading-[1.9] tracking-wide text-ink-400" data-id="element-111" data-mp="161t24t6y4olw">
          Una guía creada por Comunidad Fresh para ayudarte a conocer mejor tu
          piel y tomar decisiones más inteligentes.
        </motion.p>
      </div>
    </section>;
}